import loader from 'src/hoc/loader'

import { actionClearData, fetchGroups } from './store'
import Groups from './Groups'

const getData = async (props, dispatch) => {
  await dispatch(fetchGroups())
}

const options = {
  onUnmount: dispatch => dispatch(actionClearData()),
}

export default loader(getData, options)(Groups)
